import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

export const getCornexContactEnquiries = async (params = {}) => {
  try {
    const response = await api.get(
      `${API_URL}/cornex/contact_enquiries`,
      {
        params: params,
      }
    );
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};